import React, { useState, useEffect, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";
import { NOT_INFORMED } from "@helpers/_constants";

const getRandomColorHex = () => {
  const randomValue = Math.floor(Math.random() * 16777215).toString(16);
  return "#" + randomValue;
};

const translatedNames = [
  "Non renseigné",
  "Oui",
  "Non"
]

export default function Index({ categories = [], title, unavailabilities = [], attribut = "type" }) {
  const { t } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});
  const chartRef = useRef(null);

  const _categories = useMemo(() => {
    let formatedCategories = [...categories];
    if (unavailabilities.length) {
      const typeCount = Object.values(
        [...unavailabilities].reduce((acc, item) => {
          const typeKey = item[attribut] === false ? "Non" : item[attribut] === true ? "Oui" : (item[attribut] || NOT_INFORMED);
          acc[typeKey] = acc[typeKey] || { [attribut]: typeKey, count: 0 };
          acc[typeKey].count++;
          return acc;
        }, {})
      );

      const extTypeCount = typeCount.filter(tc => !categories.some(item => item[attribut] === tc[attribut]));

      formatedCategories = [...formatedCategories, ...extTypeCount].map(item => {
        const foundItem = typeCount.find(tc => tc[attribut] === item[attribut]);
        return ({
          _id: item[attribut],
          [attribut]: item[attribut],
          backgroundColor: item.backgroundColor || getRandomColorHex(),
          count: foundItem?.count || 0
        });
      });
    }
    return formatedCategories;
  }, [categories]);

  useEffect(() => {
    if (_categories?.length) {
      const parityData = {
        datasets: [
          {
            data: _categories?.map((item) => item.count) || [],
            backgroundColor: _categories?.map((item) => item.backgroundColor),
            hoverOffset: 4
          }
        ],
        labels: _categories.map(({ _id, count }) => {
          const percentValue = unavailabilities.length > 0 ? Math.round(count * 10000 / unavailabilities.length) / 100 : 0;
          return `${_id} : ${count} (${percentValue}%)`
        }),
      };

      setGraphData(parityData);
    }
  }, [_categories]);

  const translatedLegends = _categories
    ?.map(({ backgroundColor, ...item }) => ({
      name: translatedNames.includes(item[attribut]) ? t(item[attribut]) : item[attribut],
      backgroundColor
    }))

  const customOptions = {
    tooltips: {
      enabled: false,
      custom: (tooltip) => customTooltips(tooltip, chartRef, t),
    },
  };

  return (
    <Graph
      graphData={graphData}
      legends={translatedLegends}
      title={title}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef}
    />
  );
}
